import React, { useEffect, useState } from "react";
import { IREIGraph } from "../../interface/graph";
import { Chart } from "primereact/chart";

const Graph: React.FC<IREIGraph> = ({
  id,
  testId,
  labels,
  customOptions = {},
  style = {},
  dataSet,
  graphType,
  customClass,
  highlightIndex,
}) => {
  const [chartData, setChartData] = useState({} as any);
  const shadowColor = "rgba(180,180,180,0.25)";

  useEffect(() => {
    if (dataSet && dataSet.length > 0) {
      setChartData({
        labels: labels,
        datasets: dataSet,
      });
    }
  }, [dataSet, labels]);

  const highlightSelectedYearColumn = {
    id: "highlightSelectedYearColumn",
    afterDraw(chart, opts) {
      const { ctx, chartArea, data } = chart;

      if (!chartArea) return;

      const total = data.labels?.length || 0;
      if (total === 0) return;

      const highlightIndex = opts.index ?? 0;

      const columnWidth = chartArea.width / total;

      const left = chartArea.left + highlightIndex * columnWidth;

      ctx.save();
      ctx.fillStyle = opts.color || shadowColor;
      ctx.fillRect(left, chartArea.top, columnWidth, chartArea.bottom - chartArea.top);
      ctx.restore();
    },
  };

  return (
    <>
      <Chart
        id={id}
        data-testid={testId ?? id}
        key={`graphType`}
        type={graphType}
        data={chartData}
        options={{ ...customOptions }}
        plugins={highlightIndex ? [highlightSelectedYearColumn] : []}
        style={{ height: "100%", ...style }}
        className={customClass}
      />
    </>
  );
};

export default Graph;
